import { Box } from "@chakra-ui/react";
import { ClipLoader } from "react-spinners";
import { COLORS } from "../../utils/Colors";
import { useSelector } from "react-redux";
import { selectLoading } from "../../store/selectors/LoadingSelector";

interface LoadingProps {
  size?: "sm" | "md" | "lg";
  color?: string;
  fullScreen?: boolean;
  message?: string;
}

export const Loading = ({
  size = "md",
  color = COLORS.Brand.Primary,
  fullScreen = false,
  message = "Loading...",
}: LoadingProps) => {
  const sizeMap = {
    sm: "20px",
    md: "40px",
    lg: "60px",
  };

  const borderSizeMap = {
    sm: "2px",
    md: "3px",
    lg: "4px",
  };

  const containerStyles: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "16px",
    ...(fullScreen && {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      zIndex: 1400,
    }),
  };

  const spinnerStyles: React.CSSProperties = {
    width: sizeMap[size],
    height: sizeMap[size],
    border: `${borderSizeMap[size]} solid ${color}20`,
    borderTop: `${borderSizeMap[size]} solid ${color}`,
    borderRadius: "50%",
  };

  const messageStyles: React.CSSProperties = {
    color: COLORS.Text.Primary,
    fontSize: size === "sm" ? "14px" : "16px",
    fontWeight: 500,
  };

  const loading = useSelector(selectLoading);
  return (
    <div style={containerStyles}>
      <ClipLoader color={color} loading={loading} size={50} />
      {message && <Box style={messageStyles}>{message}</Box>}
    </div>
  );
};
